class BrandTabs extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this.items = this.querySelectorAll('.swiper-slide');
    this.tabsWrap = this.querySelectorAll('[data-brand-tabs]');
  }
  connectedCallback() {
    this.swiper = new Swiper(this.querySelector('.swiper'), {
      slidesPerView: 'auto',
      spaceBetween: 16,
      centeredSlides: true,
    });
    this.items.forEach((item) => {
      const idx = Number(item.dataset.index || 0);
      item.addEventListener('click', () => {
        this.items.forEach(i => {
          i.classList.remove('is-active');
          i.attributes['aria-selected'].value = i === item ? 'true' : 'false';
        });
        item.classList.add('is-active');
        this.swiper.slideTo(idx);
        this.scrollToPanel(idx)
      });
    });
  }
  scrollToPanel(index){
    const panelsWrap = this.querySelector('[data-panels]');
    const page = panelsWrap.clientWidth;
    const max = panelsWrap.scrollWidth - panelsWrap.clientWidth;
    const target = Math.min(Math.round(page * index), max);

    // まず強制的に位置を合わせる（これが効く）
    panelsWrap.scrollLeft = target;

    // その後、念のため smooth でも追い打ち（環境により効いたり効かなかったり）
    try {
      panelsWrap.scrollTo({ left: target, behavior: "smooth" });
    } catch (e) {
      // ignore
    }
  };
}
customElements.define('brand-tabs', BrandTabs);